<template>
  <span v-if="!header.reference">{{ item[header.value] || 'N/A' }}</span>
  <span v-else>{{ $store.state.references[header.reference]?.[header.value] ?? $store.state.references[header.reference]?.[item[header.value]] ?? item[header.value] ?? 'N/A' }}</span>
</template>

<script>
export default {
  name: 'TextContent',
  props: {
    header: {
      type: Object,
      default: () => ({})
    },
    item: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
